import Sms from "redux/reducers/sms";
import { RootState } from 'redux/store';

export const SmsSelector = {
    state: (state: RootState) => state[Sms.name],
    loading: (state: RootState) => SmsSelector.state(state).loading,
    credit: (state: RootState) => SmsSelector.state(state).credit,
    smsActivities: (state: RootState) => SmsSelector.state(state).smsActivities,
    error: (state: RootState) => SmsSelector.state(state).error,
  };